import { c as _c } from "react/compiler-runtime";
import { IcoSparkles16 } from '@onefootprint/icons';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
const SWEEP_DURATION = 1.1;
const MESSAGE_INTERVAL = 3000;
export const LoadingFallback = () => {
  const $ = _c(26);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "loadingFallback"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("idv2", t0);
  let t1;
  if ($[1] !== t) {
    t1 = t(_temp);
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t) {
    t2 = t(_temp2);
    $[3] = t;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== t) {
    t3 = t(_temp3);
    $[5] = t;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== t) {
    t4 = t(_temp4);
    $[7] = t;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== t) {
    t5 = t(_temp5);
    $[9] = t;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = [t1, t2, t3, t4, t5];
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const messages = t6;
  const [index, setIndex] = useState(0);
  const indexRef = useRef(0);
  let t7;
  if ($[17] !== messages.length) {
    t7 = () => {
      const interval = setInterval(() => {
        if (indexRef.current < messages.length - 1) {
          indexRef.current = indexRef.current + 1;
          setIndex(indexRef.current);
        }
      }, MESSAGE_INTERVAL);
      return () => clearInterval(interval);
    };
    $[17] = messages.length;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = [];
    $[19] = t8;
  } else {
    t8 = $[19];
  }
  useEffect(t7, t8);
  let t9;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <motion.span className="inline-flex" animate={{
      scale: [1, 0.85, 1]
    }} transition={{
      duration: SWEEP_DURATION * 0.8,
      repeat: Infinity,
      ease: "easeInOut"
    }}><IcoSparkles16 color="primary" /></motion.span>;
    $[20] = t9;
  } else {
    t9 = $[20];
  }
  let t10;
  let t11;
  let t12;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      backgroundPosition: ["100% center", "0% center"]
    };
    t11 = {
      duration: SWEEP_DURATION,
      repeat: Infinity,
      repeatType: "mirror",
      ease: "easeInOut"
    };
    t12 = {
      backgroundImage: "linear-gradient(90deg, currentColor 0%, rgb(160,160,160) 50%, currentColor 100%)",
      WebkitTextFillColor: "transparent"
    };
    $[21] = t10;
    $[22] = t11;
    $[23] = t12;
  } else {
    t10 = $[21];
    t11 = $[22];
    t12 = $[23];
  }
  const t13 = messages[index];
  let t14;
  if ($[24] !== t13) {
    t14 = <div className="flex h-full min-h-(--loading-container-min-height) items-center justify-center"><div className="flex items-center gap-2">{t9}<motion.span className="text-label-2 bg-clip-text [background-size:300%_100%]" animate={t10} transition={t11} style={t12}>{t13}</motion.span></div></div>;
    $[24] = t13;
    $[25] = t14;
  } else {
    t14 = $[25];
  }
  return t14;
};
function _temp($) {
  return $.processing;
}
function _temp2($_0) {
  return $_0.reviewing;
}
function _temp3($_1) {
  return $_1.verifying;
}
function _temp4($_2) {
  return $_2.finalizing;
}
function _temp5($_3) {
  return $_3.almostThere;
}